import { render, staticRenderFns } from "./ServerPage.vue?vue&type=template&id=a0370594&"
import script from "./ServerPage.vue?vue&type=script&lang=js&"
export * from "./ServerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports